import { useQuery } from "react-query";

import { makeRequest } from "../../util";
import { WebTrackerListDomainsResponse } from "../types";

export default function useFetchDomains(filter: string | null = null) {
  return useQuery<WebTrackerListDomainsResponse>(
    ["domains", filter],
    async () => {
      const req = {
        filter: filter !== null && filter.trim() !== "" ? filter : null,
      };

      const res = await makeRequest<WebTrackerListDomainsResponse>(
        "web_tracker_domains",
        req
      );

      return res.data;
    }
  );
}
